import { Helmet } from 'react-helmet';
import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const MatomoHelmet = () => {
  const {
    i18n
  } = useLingui();
  const title = i18n._({
    id: `conversational-carlead.page.title`,
    message: ''
  });
  return /*#__PURE__*/_jsxs(Helmet, {
    children: [/*#__PURE__*/_jsx("title", {
      children: title
    }), /*#__PURE__*/_jsx("meta", {
      name: "robots",
      content: "noindex,follow"
    }), /*#__PURE__*/_jsx("script", {
      children: `
          var _paq = window._paq = window._paq || [];
          /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
          _paq.push(['trackPageView']);
          _paq.push(['enableLinkTracking']);
          _paq.push(['setTrackerUrl', 'https://autohero.matomo.cloud/matomo.php']);
          _paq.push(['setSiteId', '2']);
        `
    }), /*#__PURE__*/_jsx("script", {
      src: "https://cdn.matomo.cloud/autohero.matomo.cloud/matomo.js",
      async: true
    })]
  });
};
export default MatomoHelmet;